import React from 'react';
import parse, {domToReact} from 'html-react-parser';

import Image from '../ui/components/Image';
import Link from '../ui/components/Link';
import List from '../ui/components/List';
import Headline from '../ui/components/Headline';
import {scrollToAnchorStart} from './scroll-utils';

export const parseHtmlToReact = (html = '', replacements = {}) => {
    const options = {
        replace: ({name, children, attribs}) => {
            if (name === 'img') {
                const {src, alt} = attribs;
                return <Image src={src} alt={alt} width="100%" />;
            }
            if (name === 'a') {
                const {href} = attribs;
                if (href.includes('-scroll')) {
                    return (
                        <Link
                            href={href}
                            onClick={(event) => {
                                event.preventDefault();
                                scrollToAnchorStart(
                                    href.replace('-scroll', '').replace('#', '')
                                );
                            }}>
                            {domToReact(children, options)}
                        </Link>
                    );
                }
                return <Link href={href}>{domToReact(children, options)}</Link>;
            }
            if (name === 'ul' || name === 'ol') {
                return <List type={name}>{domToReact(children, options)}</List>;
            }
            if (
                name === 'h2' ||
                name === 'h3' ||
                name === 'h4' ||
                name === 'h5' ||
                name === 'h6'
            ) {
                return (
                    <Headline type={name}>
                        {domToReact(children, options)}
                    </Headline>
                );
            }
            if (replacements[name]) {
                const Component = replacements[name];
                return (
                    <Component {...attribs}>
                        {domToReact(children, options)}
                    </Component>
                );
            }
        },
    };

    return parse(html, options);
};
